import React from "react";
import "./TermsOfService.css"; // Custom CSS for additional styling

const TermsOfService = () => {
  return (
    <div className="container privacy-policy my-5">
      <h1 className="text-center a mb-4">Terms of Service</h1>
      <p className="text-muted text-center">
        <strong>Last Updated:</strong> 21st November, 2024
      </p>
      <p>
        Welcome to Auto Motor Auctions ("we," "our," or "us"). By accessing or
        using our website www.autoauctionmall.com (the “Site”) and the services
        we offer (the “Services”), you represent that you are at least 18 years
        old, and that you have the ability to form legally binding contracts and
        you agree to comply with and be bound by the following Terms of Service
        (the "Terms"). If you do not agree with these Terms, please do not use
        the Site or Services. By using our Website, Membership Services, and
        Services, you agree that we are authorized to charge any credit card on
        file for fees, payments, and or any other amount due under this
        Agreement.
        <a
          href="https://www.AutoMotorAuctions.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.AutoMotorAuctions.com
        </a>{" "}
        (the “Site”), or use our services. By using the Site, you agree to the
        terms of this Privacy Policy.
      </p>
      {/* <h2>1. Information We Collect</h2> */}
      <h3>Acceptance of Terms</h3>
      <p>
        By using the Site, registering for an account, or engaging in any
        transactions on the Site, you agree to abide by these Terms. We reserve
        the right to modify or update these Terms at any time, and such
        modifications will be effective upon posting on this page. You should
        review these Terms regularly to stay informed about any changes.
      </p>
      {/* <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Mailing address</li>
        <li>Payment information</li>
        <li>Account information</li>
      </ul> */}

      <h3>Eligibility</h3>
      <p>
        You must be at least 18 years old and legally able to form contracts
        under applicable law to use the Site and participate in the auctions. If
        you are using the Site on behalf of an entity, you represent and warrant
        that you have the authority to bind that entity to these Terms.
      </p>
      {/* <ul>
        <li>IP address</li>
        <li>Browser type and version</li>
        <li>Referring website</li>
        <li>Pages visited on our Site</li>
        <li>Time and date of visits</li>
        <li>Device information (e.g., mobile or desktop)</li>
      </ul> */}
      {/* <p>
        This information is gathered using cookies and similar technologies, as
        described in Section 3 below.
      </p> */}

      {/* <h2>2. How We Use Your Information</h2> */}
      {/* <p>
        We use the information we collect for various purposes, including but
        not limited to:
      </p>
      <ul>
        <li>Providing, maintaining, and improving our services</li>
        <li>Processing transactions and managing accounts</li>
        <li>Responding to customer service inquiries</li>
        <li>Sending promotional and marketing communications</li>
        <li>Personalizing your experience on the Site</li>
        <li>Analyzing website usage to improve functionality</li>
        <li>Complying with legal obligations</li>
      </ul> */}

      {/* <h2>3. Cookies and Tracking Technologies</h2> */}
      <h3>Account Registration</h3>
      <p>
        To use certain features of the Site, such as participating in auctions,
        you must create an account. When registering, you agree to
      </p>
      <ul>
        <li>Provide accurate, current, and complete information.</li>
        <li>
          Maintain and promptly update your account information to ensure it
          remains accurate.
        </li>
        <li>
          Keep your account login details confidential, and notify us
          immediately if you believe your account has been compromised.
        </li>
      </ul>
      <p>
        You are responsible for all activities that occur under your account.
      </p>
      <h3>Auction Terms</h3>
      <h3> Bidding Process</h3>
      {/* <ul>
        <li>
          <strong>Essential Cookies:</strong> Necessary for the basic
          functioning of the Site (e.g., remembering your login session).
        </li>
        <li>
          <strong>Performance Cookies:</strong> Help us analyze how you use the
          Site and improve its performance.
        </li>
        <li>
          <strong>Functionality Cookies:</strong> Allow us to remember choices
          you make to enhance your experience.
        </li>
        <li>
          <strong>Advertising Cookies:</strong> Help us provide personalized
          advertisements based on your browsing behavior.
        </li>
      </ul> */}
      <p>
        Auto Motor Auctions allows users to participate in vehicle auctions
        online. By placing a bid, you agree to be bound by the terms of that
        auction, including any reserve prices, minimum bids, and applicable
        fees.
      </p>
      <ul>
        <li>
          <strong>Binding Offers:</strong> Binding Offers: Once you place a bid,
          it is considered a binding offer to purchase the vehicle.
        </li>
        <li>
          <strong>Auction Duration:</strong>Auctions will begin and end
          according to the times listed on the Auction Clearing House or Auction
          Lot, and bids placed within the last moments of the auction may extend
          the auction time.
        </li>
      </ul>
      <h3>Vehicle Description</h3>
      <p>
        While we strive to provide accurate descriptions of vehicles listed in
        auctions, all vehicles are sold as-is, where-is, with all faults and
        damages without any warranties. All information pertaining to all units
        are provided by the Auction Clearing House or Auction Lot which we are
        not in any way affiliated to, nor do we own or control in any way. We
        recommend that bidders perform their own due diligence (including
        inspection of the vehicle) before placing bids.
      </p>
      <h3>Vehicle Condition</h3>
      <p>
        You are solely responsible for any warranty service work on any vehicle
        you purchase using our Services. Purchasing a used or salvage vehicle
        from an online auto auction marketplace presents many risks. It is your
        sole responsibility to inspect any vehicle prior to placing any bid.
      </p>
      <h3>Winning Bid</h3>
      <p>
        If you are the highest bidder at the end of the auction and your bid
        meets the seller’s reserve price (if any), you will be deemed the
        winning bidder and will be required to complete the purchase of the
        vehicle according to these Terms.
      </p>
      <h3>Payment Terms</h3>
      <h3>Payment Process</h3>
      <p>
        Winning bidders must make payment within 3 working days (including the
        day of sale) following the conclusion of the auction to avoid penalty
        fees as may be imposed by the Auction Clearing House or Auction Lot.
        Payments should be made through the available payment methods specified
        on the invoice to be sent to your registered email on file (e.g., bank
        transfer, credit card, or other methods as may be specified or agreed
        upon).
      </p>
      <ul>
        <li>
          <strong>Payment Amount</strong>The total payment amount includes the
          winning bid, plus any applicable taxes, fees, and shipping or handling
          costs.
        </li>
        <li>
          <strong>Payment Assistance</strong> Subject to agreement on rate and
          availability, we may be able to help non-US buyers source USD from FX
          partners. Please note that this is entirely optional and at the
          buyer’s discretion. The usual timeline for payment initiated in this
          manner takes 1 - 3 working days for the Auction clearing house to
          receive payment. International wires or transfers may take longer due
          to no fault of ours. We will strive to ensure payment is completed in
          a timely way but we bear no responsibility for delayed payments due to
          sourcing or transfer of assisted payment for purchase made.
        </li>
        <li>
          <strong>Payment Penalties - Late Payment Fees</strong>Payments not
          received by the Auction Clearing House or Auction Lot within the
          stipulated time frame are subject to a one-time late payment fee as
          provided by the Auction Clearing House or Auction Lot.
        </li>
        <li>
          <strong>Payment Penalties - Daily Storages</strong>Units purchased as
          usually given 2 - 3 regular days free holding storage after which the
          Auction Clearing House or Auction Lot begins to charge a daily storage
          fee as stipulated by the specific Auction Clearing House or Auction
          Lot. All charges will be borne by the buyer or purchaser of the unit
          or vehicle.
        </li>
      </ul>
      <h3>Failure to Pay</h3>
      <p>
        The Auction Clearing House or Auction Lot provides 5 - 7 working days
        for payment to be received. Failure to do so will result in the vehicle
        being relisted for non-payment with penalty fees or renege fees. If you
        fail to make payment within the designated time, Auto Motor Auctions
        will deduct any penalty fees as may be imposed or demanded by the
        Auction Clearing House or Auction Lot including our service fee in full.
        We may also cancel your account, revoke your ability to participate in
        future auctions, and take other legal actions to recover the owed amount
        at our sole discretion.
      </p>
      <h3>Fees</h3>
      <p>
        By using the Services, you agree to pay any applicable fees associated
        with participating in auctions, listing vehicles, and other related
        activities. These fees are available on request and may be clearly
        outlined on the Site and may vary depending on the type of auction or
        service used. We advise that you request estimates before purchase or
        place a deposit to be sure of any and all additional charges as all
        instructions to bid, make offers, and buy now instructions are final,
        binding and irrevocable.{" "}
      </p>
      <h3>Vehicle Pickup and Delivery</h3>
      <h3>Buyer Shipping</h3>
      <p>
        The buyer is responsible for picking up the vehicle or making
        arrangements for delivery. Any costs related to shipping, handling, or
        transport of the vehicle are the responsibility of the buyer, unless
        otherwise stated.
      </p>
      <h3>Auto Motor Auctions Shipping Assistance</h3>
      <p>
        Auto Motor Auctions, subject to your permission and consent, can also
        assist with the shipping, handling, or transport of the vehicle from the
        auction lot to the port through independent shipping companies to help
        get your vehicle to your designated destination. By requesting our
        assistance with the shipping, handling, or transport of the vehicle from
        the auction lot to the port through independent shipping companies, you
        expressly agree to bear any and all costs associated with this service.
      </p>
      <h3>Prohibited Activities</h3>
      <p>
        You agree not to engage in any of the following prohibited activities
      </p>
      <ul>
        <li>Bidding without the intent to purchase.</li>
        <li>
          Manipulating the auction process, including using false identities or
          colluding with others to influence the outcome.
        </li>
        <li>
          Violating any laws or regulations related to vehicle sales, ownership,
          or transportation.
        </li>
      </ul>
      <h3>Termination of Access</h3>
      <p>
        We reserve the right to suspend or terminate your access to the Site and
        Services at our discretion, including for violations of these Terms,
        fraudulent activities, or failure to comply with payment obligations.
      </p>
      <h3>Intellectual Property</h3>
      <p>
        All content on the Site, including text, graphics, logos, images, and
        software, is owned by Auto Motor Auctions or its licensors and is
        protected by copyright, trademark, and other intellectual property laws.
        You agree not to copy, modify, distribute, or create derivative works of
        any content on the Site without prior written permission from Auto Motor
        Auctions.
      </p>
      <h3>Disclaimers</h3>
      <p>
        General Vehicle Condition and History Disclaimer All vehicles are
        "AS-IS" and "WHERE IS" and "WITH ALL FAULTS". All vehicles are sold by
        the Auction Clearing House. We do not buy or sell vehicles. You agree
        that vehicles sold via our Services are sold without any warranty,
        express or implied, including but not limited to any warranty of fitness
        for a particular purpose or warranty of merchantability. You agree that
        vehicles sold via our Services are not represented as being in
        road-worthy condition or mechanically sound. You agree that vehicles
        sold via our Services may have latent, hidden, or undisclosed damage or
        other conditions that are not immediately apparent or discoverable. You
        agree that vehicles sold via our Services may not be fit for use as a
        means of transportation, may not comply with local, state, or federal
        emissions standards, and may require substantial repairs at your
        expense. You agree that it is your sole responsibility to ascertain,
        confirm, research, inspect, and/or investigate any vehicle and all
        related Vehicle Information (as defined in Section 11.2 (Vehicle
        Information Disclaimer)) before placing any bid or purchasing any
        vehicle using our Services.
      </p>
      <p>
        Information Disclaimer Vehicle Information is provided for convenience
        only. Neither Auto Motor Auctions nor the Auction Clearing House
        guarantee that the information provided is accurate or complete.
        "Vehicle Information" means any and all information related to a vehicle
        listed on our Website, whether provided in written, oral, or digital
        form, including: year, make, model, body style, color, drive type,
        engine type, cylinders, fuel type, condition, damage amount, damage
        type, primary damage, secondary damage, mileage, odometer, odometer
        descriptions, runs and drives status, vehicle identification number
        ("VIN") or serial number, title or ownership document type, title or
        ownership document state, title or ownership document history, estimated
        retail value, actual cash value, repair estimate, estimated repair cost,
        repair history, total loss history, airbag deployment, keys, any Auction
        Highlights, and any and all other information (including images) listed
        on any lot listing page and the "Lot Details" or "Copart Auto Auction
        Lot Details" for any vehicle.
      </p>
      <p>
        The vehicles listed on our Website are not owned by us, nor are they in
        our possession. As a result, all items of Vehicle Information are
        provided by the Auction Clearing House (via Copart as the operator of
        the auction). This information is not reviewed or confirmed. Neither we,
        or the Auction Clearing House inspects any vehicles. Please be advised
        that the Vehicle Information may contain inaccuracies, errors, and
        omissions. Please note that what the auction lists as “Primary Damage”
        may not be the only damage or the most significant damage applicable to
        the vehicle in the auction listing. We expressly disclaim all
        representations, warranties, or guarantees regarding the accuracy or
        completeness of any Vehicle Information, Auction Highlights and Auction
        Lot Details. Vehicle Information is provided as a starting point for
        your research regarding the history, title, condition, and other
        information about the vehicle. We strongly encourage you to inspect, or
        retain someone to inspect on your behalf, any vehicle prior to placing
        any bid or agreeing to purchase any vehicle.
      </p>
      <p>
        You agree not to rely on any Vehicle Information, Auction Highlights, or
        Auction clearing House or Auction Lot Details in deciding whether or how
        much to bid on a vehicle.
      </p>
      <p>
        Not Professional Advice; Information Only Any information or advice
        obtained through our Services, including from our Website and our phone,
        email, and chat support services, is for informational purposes only.
        Our Support Center is available to assist you and answer your questions,
        but they are not mechanics, experts, or otherwise trained or qualified
        professionals in any vehicle-related field. They have not viewed the
        vehicle in person, nor do they have the ability to do so. As we do not
        have any information regarding the vehicle, other than what has been
        provided to us but which is unverified, if you have questions regarding
        the status, title, condition, or other element regarding the vehicle,
        you should inspect the vehicle, have the vehicle professionally
        inspected and or consult with an appropriately-trained and qualified
        professional before placing any bid or making any purchase.
      </p>
      <p>
        You agree not to rely on any information, guidance, or advice obtained
        from Auto Motor Auctions, our Website, or Copart’s website, in deciding
        whether or how much to bid on a vehicle.
      </p>
      <p>
        Keys Disclaimer Vehicles purchased via our Services are not represented,
        warrantied, or guaranteed to have keys or that keys will be available
        for any vehicle purchased using our Services, regardless of whether the
        auction listing indicated the vehicle comes with keys, keys are present
        in images, or keys were present in the vehicle prior to the time of
        purchase.
      </p>
      <p>
        Title and Registration Laws Disclaimer Due to variations in applicable
        laws and regulations, a vehicle listed with a "clean" or "clear" or
        other similar title or ownership document type may have a salvage, junk,
        or other history. Regardless of whether the title or ownership document
        type is listed as "clean" or "clear" or does not otherwise indicate a
        salvage history on the auction listing, the title or ownership document
        may become a salvage, reconstructed, or an otherwise branded title or
        ownership document upon registration in your state or any other
        jurisdiction. (For example, a vehicle legally purchased by you with a
        clean title in State A may be required to be sold on a salvage title if
        you transport and register or resell the vehicle in State B.)
      </p>
      <h3>Indemnification</h3>
      <p>
        You agree to indemnify, defend, and hold Auto Motor Auctions and its
        affiliates, officers, directors, employees, and agents harmless from any
        claims, damages, liabilities, and expenses (including legal fees)
        arising from your use of the Site, violation of these Terms, or any
        actions that result from your auction activities.
      </p>
      <h3>Privacy Policy</h3>
      <p>
        Your use of the Site is also governed by our Privacy Policy, which can
        be found at [link to Privacy Policy]. By using the Site, you consent to
        the collection and use of your information in accordance with our
        Privacy Policy.
      </p>
      <h3>Governing Law</h3>
      <p>
        These Terms shall be governed by and construed in accordance with the
        laws of Lagos State, Nigeria, without regard to its conflict of law
        principles. Any disputes arising out of or relating to these Terms shall
        be subject to the exclusive jurisdiction of the courts located in
        Nigeria.
      </p>
      <h3>Changes to These Terms</h3>
      <p>
        We reserve the right to modify or update these Terms at any time. Any
        changes will be posted on this page with an updated "Last Updated" date.
        Continued use of the Site after such changes constitutes acceptance of
        the revised Terms.
      </p>
      {/* <h2>4. Sharing Your Information</h2> */}
      {/* <p>
        We do not sell your personal information. However, we may share your
        information in the following situations:
      </p>
      <ul>
        <li>
          <strong>With Service Providers:</strong> Third-party service providers
          that help us operate the Site and provide services.
        </li>
        <li>
          <strong>With Affiliates:</strong> To provide you with a seamless
          experience across our services.
        </li>
        <li>
          <strong>For Legal Compliance:</strong> If required by law or in
          response to legal processes.
        </li>
        <li>
          <strong>Business Transfers:</strong> Your information may be
          transferred as part of a merger, acquisition, or sale of assets.
        </li>
      </ul> */}

      {/* <h2>5. Your Rights and Choices</h2> */}
      {/* <p>
        Depending on your location, you may have certain rights regarding your
        personal information, including the right to:
      </p>
      <ul>
        <li>Access, update, or delete your personal information</li>
        <li>Opt-out of marketing communications</li>
        <li>Control cookies and tracking technologies</li>
      </ul> */}
      {/* <p>
        If you would like to exercise any of these rights or have questions,
        please contact us at the details provided below.
      </p> */}

      {/* <h2>6. Data Security</h2> */}
      {/* <p>
        We take reasonable measures to protect your personal information from
        unauthorized access, use, or disclosure. However, no method of data
        transmission or storage is 100% secure.
      </p> */}

      {/* <h2>7. Third-Party Links</h2> */}
      {/* <p>
        Our Site may contain links to third-party websites. We are not
        responsible for the privacy practices or content of those sites. Review
        their privacy policies for details.
      </p> */}

      <h3>Contact Us</h3>
      <p>
        If you have any questions or concerns about these Terms, please contact
        us at
      </p>
      <address>
        <strong>Auto Motor Auctions LLC</strong>
        <br />
        Attn: Privacy Department
        <br />
        Email:{" "}
        <a href="mailto: info@automotorauctions.com">
          info@automotorauctions.com
        </a>
        <br />
        Phone: <a href="tellto:+19299889960">+19299889960</a>
      </address>
    </div>
  );
};

export default TermsOfService;
